angular.module('rjmNg.directives').directive "chartTypeSelect", [
  () ->
    restrict: "E"
    templateUrl: "directive.chartTypeSelect.html"
    replace: false
    controllerAs: "view"
    bindToController: true
    scope:
      chartType: "="
      reportType: "<"
    controller: [
      "$rootScope"
      "figureEnums"
      (
        $rootScope
        figureEnums
      ) ->

        view = @

        view.setChartType = (type) ->
          view.chartType = type
          $rootScope.$broadcast "setChartType", type
        view.$postLink = () ->
            view.chartTypes = figureEnums.SQL_CHART_TYPES
        return view
    ]
]